module.exports = __webpack_public_path__ + "img/parts_grey.1a569e0a.svg";